module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.e66ad95c.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }